// extracted by mini-css-extract-plugin
module.exports = {"users":"Users_users__2qxc0","menu":"Users_menu__1gCtI","email":"Users_email__1HyKl"};